module.exports = __webpack_public_path__ + "img/pattern.3a849bde.png";